import request from '@/utils/request'

const send = phoneNumber => {
  return request({
    url: '/api/otp/send',
    method: 'post',
    data: {
      phoneNumber
    }
  })
}

const verify = (otpToken, otpCode) => {
  return request({
    url: '/api/otp/verify',
    method: 'post',
    data: {
      otpToken,
      otpCode
    }
  })
}

export default {
  send,
  verify
}
